<template>
    <div class="premium--lock-down" @click.stop="showUpgrade">
        <div style="text-align: center; padding: 20px 30px; line-height: 1.4;">
            <h3>Your Premium Access<br/>has expired</h3>
            <br/>
            <div style="font-size: 13px; line-height: 1.4;">

            We don't have ad-supported option since we don't want to sell your data or take your precius time with ads. DentiCalc is an app to explain, not a place for advertising and using DentiCalc even once or twice a month can save you much more than what it costs.

            <br/><br/>
        </div>
            <div style="background: rgba(0,0,0,.4); box-shadow: 0 0 15px rgba(255,255,255,.5); font-weight: 600; color: #fff; padding: 8px 16px; display: inline-block; border: 2px solid #fff; border-radius: 20px;">SHOW PREMIUM PLANS</div>

            <br/><br/><br/>
            <div style="font-size: 13px; line-height: 1.4;">
                <span style="font-weight: 600;">"Why not free with ads?"</span><br/><br/>
                In the most of the free apps you become the product.
                We don't want to sell your data or take your precius time with ads.
                DentiCalc is an app to explain, not a place for advertising.
            </div>
        </div>
    </div>
</template>

<style scoped>
    .premium--lock-down {
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0px;
        top: 0px;
        left: 0;
        bottom: 0;
        cursor: pointer;
        background: rgba(11, 33, 167,.7);
        color: #fff;
        backdrop-filter: blur( 6px );
        -webkit-backdrop-filter: blur( 6px );
        font-size: 16px;
    }

    .premium--lock-down h3 {
        font-size: 24px;
        font-weight: 600;
        text-transform: uppercase;
    }

    @media (min-width: 700px) {
        .premium--lock-down {
            --top-height: 52px;
            --bottom-height: 70px;
            height: calc(100vh - var(--top-height, 52px) - var(--bottom-height, 70px)) !important
        }
    }
</style>

<script>

export default {
    methods: {
        showUpgrade() {
            this.$bus.$emit("free_trial:show", {
                countdown: 0,
                route: '',
            });
        },
    },
}
</script>
